// extracted by mini-css-extract-plugin
module.exports = {"QuantityButton":"quantity_button_QuantityButton__100Je"};